import React from 'react';
import { motion } from 'framer-motion';

const SECTION_ANIMATIONS = {
  INITIAL: { opacity: 0 },
  ANIMATE: {
    y: 0,
    opacity: 1
  },
  EXIT: {
    y: -10,
    opacity: 0
  }
};

/**
 * @typedef {object} MotionSectionProps
 * @property {string} [keyProp]
 * @property {React.ReactNode} children
 */

/**
 * @param {MotionSectionProps} props
 */
const MotionSection = props => {
  const { keyProp, children } = props;

  return (
    <motion.section
      key={keyProp}
      transition={{ duration: 0.2, delay: 0.1 }}
      initial={SECTION_ANIMATIONS.INITIAL}
      animate={SECTION_ANIMATIONS.ANIMATE}
      exit={SECTION_ANIMATIONS.EXIT}>
      {children}
    </motion.section>
  );
};

export default MotionSection;
